import {
  getCategoryProducts,
  CategoryParams,
  Product,
} from "@repo/apis/browse-search-v2";

type CommonParams = Omit<CategoryParams, "categoryId"> & {
  categoryIds: number[];
  limits: number[];
};

export const fetchCategoryProducts = async (
  params: CommonParams,
): Promise<Product[]> => {
  const { categoryIds, limits } = params;
  const categoriesProducts = await Promise.all(
    categoryIds.map((categoryId, index) =>
      getCategoryProducts({
        categoryId,
        limit: limits[index] ?? 30,
        sort: "freshness",
        ...params,
      }),
    ),
  );
  return categoriesProducts.flatMap((r) => r.products);
};
